/* eslint-disable camelcase */
import React, { Component } from "react";
import PropTypes from "prop-types";

import i18n from "i18n-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withRouter, Redirect, Link } from "react-router-dom";

import { Progress, Image } from "C4";

const Overlay = (props) => {
  const { id } = props;
  return (
    <div id={`overlay_${id}`} className="overlay">
      <i id={`lock_${id}`} className="fas fa-lock" />
    </div>
  );
};

class TrainingCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: "",
      loading: true,
    };
  }

  redirect(url, page, path) {
    const { redirPath } = this.props;
    if (page === undefined) {
      return `${path !== undefined ? path : redirPath}${url}/0`;
    }
    return `${path !== undefined ? path : redirPath}${url}/${page}`;
  }

  render() {
    const {
      appId,
      chapter,
      chapterCount,
      chaptersProgress,
      index,
      locked,
      lockedSubtitle,
      redirPath,
      comingSoon,
    } = this.props;

    const { chapterImage, chapterID, chapterTitle } = chapter;
    const { percentage, last_page, total_pages } = chaptersProgress[0];

    const { loading, redirect } = this.state;

    let buttonText;
    let redir;
    switch (percentage) {
      case 100:
        buttonText = i18n.translate("trainingScreens.restart");
        redir = `/main/ret/chapter/${chapterID}/0`;
        break;
      case undefined:
      case 0:
        buttonText = i18n.translate("trainingScreens.start");
        break;
      default:
        buttonText = i18n.translate("trainingScreens.continue");
    }

    if (chapterID === "2918") {
      redir = `/main/ret/chapter/${chapterID}/0`;
    }

    if (redir === undefined) {
      redir = this.redirect(chapterID, last_page);
    }

    const title = chapterTitle.split(":");

    const lastPage = () => {
      let page = 0;
      if (total_pages !== 0 && last_page === total_pages) {
        page = 0;
      } else if (total_pages !== 0 && last_page !== total_pages) {
        page = last_page;
      }

      return page;
    };

    let link = `/main/training/chapter/${chapterID}/${lastPage()}`;
    if (window.location.pathname === "/main/retain") {
      link = `/main/ret/chapter/${chapterID}/0`;
    }

    return (
      <Link
        role="button"
        tabIndex={index}
        to={link}
        className={`trainingCard ${loading ? "loading" : ""} ${
          locked ? "locked" : ""
        }`}
      >
        <div className="textContainer">
          {!loading && (
            <div>
              {comingSoon && <h4>Coming Soon: {chapterTitle}</h4>}
              {!comingSoon && (
                <React.Fragment>
                  <h3
                    dangerouslySetInnerHTML={{
                      __html: title[0].replace("&", "</br>&"),
                    }}
                  />
                  <span>{title[1]}</span>
                </React.Fragment>
              )}
              {!locked && (
                <p className="duration">
                  <FontAwesomeIcon icon={["far", "clock"]} />
                  {` ${chapterCount} ${i18n.translate(
                    "trainingScreens.durationInMinutes"
                  )}`}
                </p>
              )}
              {!locked && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    redir(redirPath);
                  }}
                >
                  {buttonText}
                </button>
              )}
              {lockedSubtitle && locked && (
                <p>
                  {i18n.translate("trainingScreens.unlock", {
                    number: index + 1,
                  })}
                </p>
              )}
              {!lockedSubtitle && locked && (
                <p>
                  {i18n.translate("trainingScreens.unlock", { number: index })}
                </p>
              )}
            </div>
          )}
        </div>
        <div className="imageContainer">
          <Image
            appId={appId}
            load={() => {
              this.setState({ loading: false });
            }}
            src={`https://front.travpromobile.com/778/${chapterImage}`}
            alt={chapterTitle}
            gradient
            staticImage
          />
          {!loading && locked && <Overlay id={index} />}
          {!loading && (
              <span className="chapterNumber">{`0${index + 1}`.slice(-2)}</span>
            ) && (
              <span className="chapterComplete">
                {percentage === 100 && !locked && (
                  <FontAwesomeIcon
                    icon={["far", "check-circle"]}
                    className="chapterComplete"
                  />
                )}
              </span>
            )}
        </div>
        {!locked && !loading && <Progress id={index} value={percentage} />}
        {!locked && redirect.length > 0 && <Redirect to={redirect} />}
      </Link>
    );
  }
}

export default withRouter(TrainingCard);

TrainingCard.propTypes = {
  appId: PropTypes.number.isRequired,
  chapter: PropTypes.shape({
    chapterID: PropTypes.string,
    chapterImage: PropTypes.string,
    chapterImagePro: PropTypes.string,
    chapterItemCount: PropTypes.number,
    chapterNumber: PropTypes.string,
    chapterTitle: PropTypes.string,
  }).isRequired,
  chapterCount: PropTypes.number,
  chaptersProgress: PropTypes.shape({
    chapter: PropTypes.string,
    last_page: PropTypes.number,
    percentage: PropTypes.number,
    progress: PropTypes.number,
    total_pages: PropTypes.number,
  }),
  index: PropTypes.number.isRequired,
  locked: PropTypes.bool,
  comingSoon: PropTypes.bool,
  lockedSubtitle: PropTypes.string,
  redirPath: PropTypes.string,
};

TrainingCard.defaultProps = {
  chapterCount: 0,
  chaptersProgress: {},
  locked: false,
  redirPath: "/main/training/chapter/",
  lockedSubtitle: null,
  comingSoon: false,
  // lockedSubtitleRedirect: '',
};

Overlay.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};
